import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ReviewsService} from '../../../services/reviews.service';
import {Review} from '../../../models/review';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-review-view',
  templateUrl: './review-view.component.html',
  styleUrls: ['./review-view.component.scss']
})
export class ReviewViewComponent implements OnInit {

  review: Review = new Review();
  statusList = ['NOT_STARTED', 'PENDING', 'COMPLETE'];

  constructor(private reviewsService: ReviewsService,
              private utilsService: UtilsService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.reviewsService.findOneReview(id).subscribe(result => {
      if (result && result.data && result.data['review']) {
        this.review = JSON.parse(JSON.stringify(result.data['review']));
        this.utilsService.openSnackBar('Review Loaded !!', '');
      } else {
        console.error('Review data is missing or undefined:', result);
      }
    }, error => {
      console.error('Error fetching review:', error);
    });
  }

  updateReview() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.review.clientName, this.review.status, this.review.review);
    if (requiredSuccess) {
      this.reviewsService.updateReview(this.review).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Review Updated !!', '');
          // this.router.navigate(['/reviews/' + this.review.organization.id]);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update review.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

  deleteReview() {
    if (window['UIkit']) {
      window['UIkit'].modal($('#confirm-delete')).hide();
    }
    $('#confirm-delete').remove();
    this.reviewsService.deleteReview(this.review.id).subscribe(({data}) => {
      this.utilsService.openSnackBar('Review Deleted !!', '');
      this.router.navigate(['/reviews/' + this.review.organization.id]);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete review.', '');
      console.log('there was an error sending the query', error);
    });
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/reviews/review-view/review-view.component.ts